module.exports = __webpack_public_path__ + "static/img/zhou.46f5af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhou.png
// module id = 92
// module chunks = 1